import { DecoratedForm, FormOptions } from '../types';

export function Form(options: Partial<FormOptions> = {}) {
  return function <T extends new (...args: any[]) => DecoratedForm>(constructor: T) {
    return class extends constructor {
      _options = options;
    };
  };
}
